import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { dismissNotification } from '../../reducers/notifications';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import './notifications.css';

class Notifications extends React.Component {
    constructor(props) {
        super(props);
        this.state = { element: null };

        this.onClick = this.onClick.bind(this);
        this.onClose = this.onClose.bind(this);
        this.remove = this.remove.bind(this);
    }

    onClick(event) {
        const { notifications } = this.props;
        if (notifications && notifications.length > 0) {
            this.setState({ ...this.state, element: event.currentTarget });
        }
    }

    onClose() {
        this.setState({ ...this.state, element: null });
    }

    remove(notification) {
        const { dismissNotification } = this.props;
        this.onClose();
        dismissNotification(notification);
    }

    render() {
        let { element } = this.state;
        let { notifications } = this.props;

        return (
            <div>
                <div className="notifications-box no-select" aria-owns={element ? 'user-menu' : null} aria-haspopup="true" onClick={this.onClick}>
                    {notifications.length > 0 && <span className="notifications-count">{notifications.length > 99 ? '99+' : notifications.length}</span>}
                    <i className="material-icons">notifications_none</i>
                </div>
                <Menu id="user-menu" anchorEl={element} onClose={this.onClose} open={Boolean(element)}>
                    {notifications.map((n, i) => (
                        <MenuItem key={i} onClick={() => this.remove(n)}>
                            <span>{n}</span>
                        </MenuItem>
                    ))}
                </Menu>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    role: state.identity.role,
    profile: state.identity.profile,
    notifications: []
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            dismissNotification
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);



// WEBPACK FOOTER //
// ./src/components/notifications/index.jsx